import { Component, OnInit } from '@angular/core';
import { CompanyTiers, PlatformService } from 'src/app/services/vendor/platform.service';
import { PaymentHandlerService } from 'src/app/services/vendor/payment-handler.service';
import { NavigatorService } from 'src/app/services/vendor/navigator.service';
import { CompanyProfile, Profile, StripePaymentSubscriptionDetails } from 'src/app/data-models/models';

@Component({
  selector: 'app-subscription-monthly',
  templateUrl: './vendor-subscription-monthly.component.html',
  styleUrls: ['./vendor-subscription-monthly.component.scss']
})
export class SubscriptionMonthlyComponent implements OnInit {
  // public items = [
  //   { name: 'Swarm', price: 1, desc: '*PER TRANSACTION', setUpFee: '99', isFree: true },
  //   // { name: 'Housecall Pro', price: 299, desc: '*MAX 9 USERS', setUpFee: '0' },
  //   { name: 'Service Fusion', price: 489, desc: '*PER USER', setUpFee: '500' },
  //   { name: 'Field Edge', price: 150, desc: '*PER USER', setUpFee: '1000-4000' },
  //   { name: 'Service Titan', price: 245, desc: '*PER USER', setUpFee: '800' }
  // ]
  
  private companyTierPricing = this.platformService.getTiers();
  private profile: Profile = this.navigatorService.getCurrentProfile();
  public companyProfile: CompanyProfile | null = null;


  public items = [
    { 
      name: 'Starter', 
      subtitle: 'Perfect for solo operators or small teams',
      price: 99, 
      tier: CompanyTiers.STARTER,
      product: this.companyTierPricing[CompanyTiers.STARTER].priceId,
      platformServiceFeeId: this.companyTierPricing[CompanyTiers.STARTER]?.platformServiceFeeId,
      aiCallingMinutesId: this.companyTierPricing[CompanyTiers.STARTER]?.aiCallingMinutesId,
      desc: '+ 1% PER TRANSACTION', 
      setUpFee: '0', 
      standout: false, 
      features: [
        { title: "Core Modules Unlocked", available: true },
        { title: "AI Operations", available: true },
        { title: "AI Calling", available: true },
        { title: "AI Dispatcher", available: true },
        { title: "AI Scheduling", available: true },
        { title: "AI Inventory Management", available: false },
        { title: "* Standard Leads", available: false },
        { title: "Advanced Reporting", available: false },
        { title: "200 Monthly AI Calling Minutes", available: false }
      ]
    },
    { 
      name: 'Growth', 
      subtitle: 'Scale ops + get leads flowing', 
      price: 199, 
      tier: CompanyTiers.GROWTH,
      product: this.companyTierPricing[CompanyTiers.GROWTH].priceId,
      platformServiceFeeId: this.companyTierPricing[CompanyTiers.GROWTH]?.platformServiceFeeId,
      aiCallingMinutesId: this.companyTierPricing[CompanyTiers.GROWTH]?.aiCallingMinutesId,
      desc: '+ 1% PER TRANSACTION', 
      setUpFee: '0', 
      standout: true,  
      features: [
        { title: "Core Modules Unlocked", available: true },
        { title: "AI Operations", available: true },
        { title: "AI Calling", available: true },
        { title: "AI Dispatcher", available: true },
        { title: "AI Scheduling", available: true },
        { title: "AI Inventory Management", available: true },
        { title: "* Standard Leads", available: true },
        { title: "Advanced Reporting", available: false },
        { title: "200 Monthly AI Calling Minutes", available: false }
      ]
    },
    { 
      name: 'Pro', 
      subtitle: 'Maximize growth with AI + lead dominance', 
      price: 299, 
      tier: CompanyTiers.PRO,
      product: this.companyTierPricing[CompanyTiers.PRO].priceId,
      platformServiceFeeId: this.companyTierPricing[CompanyTiers.PRO]?.platformServiceFeeId,
      aiCallingMinutesId: this.companyTierPricing[CompanyTiers.PRO]?.aiCallingMinutesId,
      desc: '+ 1% PER TRANSACTION', 
      setUpFee: '0', 
      standout: false, 
      features: [
        { title: "Core Modules Unlocked", available: true },
        { title: "AI Operations", available: true },
        { title: "AI Calling", available: true },
        { title: "AI Dispatcher", available: true },
        { title: "AI Scheduling", available: true },
        { title: "AI Inventory Management", available: true },
        { title: "* Priority Leads", available: true },
        { title: "Advanced Reporting", available: true },
        { title: "200 Monthly AI Calling Minutes", available: true }
      ] 
    },
  ]

  constructor(
    private navigatorService: NavigatorService, 
    private platformService: PlatformService,
    private paymentHandlerService: PaymentHandlerService
  ) { }

  async ngOnInit() {
    this.companyProfile = await this.navigatorService.getCompanyProfile(this.profile?.company_id);
    console.log("Company Profile: ", this.companyProfile);
  }

  public subscribe(item) { 
    const profile: Profile = this.navigatorService.getCurrentProfile();

    // export interface StripePaymentSubscriptionDetails {
    //   stripeAccount: string | null;
    //   paymentDetails: Array<StripePaymentSubscriptionLineItems>;
    //   discount?: number;
    // }
    
    // export interface StripePaymentSubscriptionLineItems {
    //   price: string, // Product ID
    //   quantity: number
    // }

    const paymentDetails: StripePaymentSubscriptionDetails = {
      stripeAccount: null,
      paymentDetails: [
        {
          price: item?.product,
          quantity: 1
        },
        {
          price: item?.platformServiceFeeId // Metered so no need for quantity
        },
        {
          price: item?.aiCallingMinutesId // Metered so no need for quantity
        },
      ]
    };

    console.log("Payment Details: ", paymentDetails);
    
    this.paymentHandlerService.makePlatformStripeSubscription(paymentDetails, null, profile?.company_id, item?.tier);
  }

  public cancelSubscription() { 

    if(!this.companyProfile?.stripeSubscriptionId)
      return;

    const subscriptionId: string = this.companyProfile?.stripeSubscriptionId;
    
    this.paymentHandlerService.cancelPlatformStripeSubscription(subscriptionId, this.companyProfile?.id);
  }

}
